import { ArrowTriangleDownIcon } from '@tableau/icons/ArrowTriangleDownIcon';
import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { InvertTextColors, TextColors } from '../../styles/Colors';
import { SVGAttrs } from '../../utils/HtmlAttrs';
import { IconState, IconStyle } from '../Icons';

const DropdownArrowStyleName = TypeStyle.style({
  color: TextColors.Primary,
  $nest: {
    '&.onDarkBackground': { color: InvertTextColors.Primary },
    '&.onDarkBackground.active': { color: InvertTextColors.Primary },
    '&.onDarkBackground.hover': { color: InvertTextColors.Primary },
    '&.onDarkBackground.disabled': { color: InvertTextColors.Disabled },
    '&.disabled': { color: TextColors.Disabled },
    '&.active': { color: TextColors.Primary },
    '&.hover': { color: TextColors.Primary },
  }
});

const DropdownArrowIconElement: React.FC<Pick<IconState, 'active' | 'disabled' | 'hover' | 'onDarkBackground'> & Pick<SVGAttrs, 'style'>> = props => {
  const { active, disabled, hover, onDarkBackground, style } = props;

  return <ArrowTriangleDownIcon
    aria-hidden
    className={TypeStyle.classes(DropdownArrowStyleName, { active, disabled, hover, onDarkBackground })}
    size={18}
    style={{ ...IconStyle, ...style }}
  />;
};

export const DropdownArrowIcon = {
  height: 18,
  width: 18,
  icon: DropdownArrowIconElement,
};
